import { render } from "./KanbanGrid.vue?vue&type=template&id=5b713c7a"
import script from "./KanbanGrid.vue?vue&type=script&lang=js"
export * from "./KanbanGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__